import { render } from "./EditProductPage.vue?vue&type=template&id=5d71b6cc&scoped=true&ts=true"
import script from "./EditProductPage.vue?vue&type=script&lang=ts"
export * from "./EditProductPage.vue?vue&type=script&lang=ts"

import "./EditProductPage.vue?vue&type=style&index=0&id=5d71b6cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d71b6cc"]])

export default __exports__